export default {
  pricing: {
    title: "Prezzi",
    hero: {
      title: "Un abbonamento. Accesso totale.",
      subtitle: "Inizia gratis. Sblocca l'esperienza completa su web e mobile.",
      newsletterTitle: "1 year of Linemate+ for $45",
      newsletterSubtitle: "Your discount code is automatically applied at checkout, so just choose the annual plan and you’re good to go.",
      newsletterPriceLine: "US$44.99 per tutto l'anno",
      newsletterRenewLine: "Si rinnova a US$59.99/anno",
    },
    plans: {
      free: {
        features: [
          "Giocate giornaliere in tendenza",
          "Tassi di successo di squadre e giocatori",
          "Registro partite e storico rendimento",
        ],
      },
      annual: {
        billingShort: "anno",
        billingLong: "annualmente",
        features: [
          "Include tutto del piano gratuito +",
          "Ogni segnale di giocata e analisi completa",
          "Formazioni iniziali, impatto infortuni e meteo",
          "Accesso esclusivo a ogni parlay",
          "Insight più profondi su tutti i parlay in tendenza",
          "Filtri di ricerca avanzati",
          "Opzione per selezionare e modificare la visualizzazione quote",
        ],
      },
      monthly: {
        billingShort: "mese",
        billingLong: "mensilmente",
        features: [
          "Include tutto del piano gratuito +",
          "Ogni segnale di giocata e analisi completa",
          "Formazioni iniziali, impatto infortuni e meteo",
          "Accesso esclusivo a ogni parlay",
          "Insight più profondi su tutti i parlay in tendenza",
          "Filtri di ricerca avanzati",
          "Opzione per selezionare e modificare la visualizzazione quote",
        ],
      },
    },
    actions: {
      currentPlan: "Il tuo piano attuale",
      manage: "Gestisci",
      upgrade: "Upgrade",
    },
    badges: {
      mostPopular: "Più popolare",
      annualSavings: "Risparmia fino al 60% con il piano annuale",
    },
    operators: {
      prefix: "Completamente integrato con",
      highlight: "operatori globali",
      suffix: "per un'esperienza fluida dalla ricerca alla scommessa",
    },
    sections: {
      fullPicture: "Vedi il quadro completo prima di scommettere",
      signals: "Sblocca tutti i segnali per un contesto migliore",
    },
    testimonials: {
      trusted: "Scelto da<br/>900k scommettitori sportivi",
      betslips: "Oltre<br/>1M+ betslip creati",
      previous: "Testimonianze precedenti",
      next: "Testimonianze successive",
      items: [
        {
          title: "Davvero l'app meglio progettata che abbia visto da un po'.",
          description: "Tutto è esattamente dove deve essere, ogni selezione funziona come previsto, e l'app è progettata con grande cura. È ricca di informazioni, ma resta efficiente e organizzata. Da appassionato di statistiche, apprezzo molto il design di Linemate e la facilità nel trovare buone giocate.",
        },
        {
          title: "La migliore app di tutte",
          description: "Questa è al 100% la migliore app per scommesse sportive. Dopo averla provata per qualche giorno ero convinto. Consiglio molto la versione a pagamento per sfruttare tutto ciò che offre. Non resterai deluso.",
        },
        {
          title: "La migliore",
          description: "Ho provato tante app di statistiche. Linemate è quella a cui torno sempre. Offrono molto gratis, continuano ad aggiungere funzionalità senza togliere nulla, e il piano Plus vale davvero il prezzo. Il supporto ha risposto in 5 minuti. Si vede che vogliono essere l'app di riferimento.",
        },
        {
          title: "Piacevolmente sorpreso",
          description: "Se sei nuovo e segui le props alla cieca, i risultati varieranno; serve comunque una strategia. Ho scaricato Linemate dopo che i miei parlay mancavano sempre di poco, e il mio primo parlay da 7 leg su props giocatore è andato a segno. Con la prima settimana gratuita, il prezzo mensile vale facilmente la pena.",
        },
        {
          title: "Ottima app!",
          description: "Nessuna app di scommesse è perfetta, ma questa mi ha dato finora i risultati migliori. Tutto si basa su statistiche e dati reali. La versione gratuita è solida, e l'abbonamento è ancora meglio.",
        },
        {
          title: "Un'app che si distingue",
          description: "Un'ottima app che si distingue davvero, conveniente e con funzionalità forti per la ricerca. Nel complesso, ottimo lavoro.",
        },
      ],
    },
    comparison: {
      premium: "Annuale/Mensile",
      included: "Incluso",
      notIncluded: "Non incluso",
    },
    popup: {
      billedAnnually: "Fatturato annualmente",
      savePercent: "Risparmia {{percent}}%",
      upgradeForJust: "Fai upgrade per soli {{price}}/{{billingPeriod}}",
      dismiss: "Chiudi",
    },
  },
};
